<template>
  <SocialMentionCard
    v-bind="{ ...$props, ...$attrs }"
    class="pointer"
    :icon="socialIcon(mention.type)"
    :list-title="listTitle"
    @click="$emit('click', $event)"
    @mention-removed="removeMention"
    @mention-selected="$emit('mention-selected', $event)"
  >
    <template #header>
      <span class="title bold">
        {{ lowerCase(mention.source.name) }}

        <strong> · </strong>
        <template v-if="mention.author">
          <span class="text-blue-grey subtitle">{{
            $t("global.posted_by")
          }}</span>
        </template>

        <template v-else>
          <span class="text-blue-grey subtitle">
            <TimeAgo
              class="text-blue-grey self-start"
              :date="mention.timestamp"
            />
          </span>
        </template>
      </span>

      <template v-if="mention.author">
        <span class="text-blue-grey subtitle">
          {{ mention.author }}

          <TimeAgo
            class="text-blue-grey self-start"
            :date="mention.timestamp"
          />
        </span>
      </template>
    </template>

    <template #beforeExcerpts>
      <strong class="bold q-mb-md block">
        {{ mention.title }}
      </strong>
    </template>

    <slot />
  </SocialMentionCard>
</template>

<script>
import { propsExcept, SocialMentionCard } from "shared/components/MentionCard";
import { socialIcon } from "shared/helpers/media";
import { lowerCase } from "shared/helpers/string";

export default {
  name: "SocialMentionCardBlogPost",
  components: {
    SocialMentionCard,
  },
  props: {
    ...propsExcept(["listTitle"]),
  },
  emits: ["click", "mention-selected", "mention-removed"],
  computed: {
    listTitle() {
      return this.mention.title;
    },
  },
  methods: {
    lowerCase,
    socialIcon,
    removeMention(mention) {
      this.$emit("mention-removed", mention);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-icon {
  &.ion-checkmark-circle {
    color: rgb(73 208 103 / 50%);
  }

  &.ion-close-circle {
    color: rgb(249 88 88 / 50%);
  }

  &.ion-remove-circle {
    color: rgb(50 159 236 / 50%);
  }
}

.social-verified {
  vertical-align: 0;
  margin-left: 3px;
}
</style>
